"use strict";

exports.__esModule = true;
exports.useAiDraftsStore = useAiDraftsStore;
var _react = require("react");
var _featureFlags = require("../../../featureFlags");
var _EnvContext = require("../../Env/EnvContext");
var _RestAPIContext = require("../../API/RestAPI/RestAPIContext");
var _aiDraftsStore = require("./aiDraftsStore");
/**
 * The browser store for AI-made documents of one kind ("dashboards" or
 * "reports"), or undefined while ENABLE_AI_AUTHORING is off, so a collection
 * can take it as its `localStore` without caring whether the feature is on.
 */
function useAiDraftsStore(kind) {
  var env = (0, _react.useContext)(_EnvContext.EnvContext) || {};
  var api = (0, _react.useContext)(_RestAPIContext.RestAPIContext);
  var enabled = Array.isArray(env.featureFlags) && env.featureFlags.includes(_featureFlags.ENABLE_AI_AUTHORING);
  var plantName = api && api.plantName;
  return (0, _react.useMemo)(function () {
    return enabled ? (0, _aiDraftsStore.createAiDraftsStore)(plantName, kind) : undefined;
  }, [enabled, plantName, kind]);
}